import { useEffect, useState } from "react";
import { Alert, Breadcrumb, Button, Skeleton, Spin } from "antd";
import axiosConfig from "../../../util/axiosConfig";
import { TrucksType } from "../../../shared/interfaces/trucks.interface";
import { Link, useParams } from "react-router-dom";
import { useCallback } from "react";
import requestErrorHandler from "../../../util/requestErrorHandler";
import useQuery from "../../../hooks/useQuery";
import PageSpinner from "../../../components/PageSpinner";
import { socket } from "../../../util/socket";
import MapView from "../../../components/MapView";
import disabledMap from "../../../assets/disabled-map.png";

const BASE_URL = process.env.REACT_APP_BASE_URL!;

const Tracking = () => {
  const { truckId } = useParams();

  const deviceObjectId = useQuery().get("deviceObjectId");
  const currentTrip = useQuery().get("currentTrip");
  const numOfTrips = useQuery().get("numOfTrips");

  const [isLoading, setIsLoading] = useState(false);
  const [devicePosition, setDevicePosition] = useState<DevicePosition>();
  const [truck, setTruck] = useState<TrucksType>();

  const getTruck = useCallback(async () => {
    setIsLoading(true);
    await axiosConfig
      .get(`${BASE_URL}/customer-trucks/get-one?truckId=${truckId}`)
      .then((response: any) => {
        setTruck(response.data.truck);
      })
      .then(async () => {
        return getTruckPosition();
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const getTruckPosition = async () => {
    const {
      data,
    }: {
      data: {
        message: string;
        position: { locationDetails: DevicePosition };
      };
    } = await axiosConfig.get(
      `${BASE_URL}/eonsfleet/get-postion?deviceObjectId=${deviceObjectId}`
    );

    setDevicePosition(data?.position?.locationDetails);
    return data?.position?.locationDetails;
  };

  useEffect(() => {
    getTruck();
    socket.connect();

    socket.on("locationStatus", (data) => {
      if (
        data?.locationDetails?.DeviceObjectId === devicePosition?.DeviceObjectId
      ) {
        setDevicePosition(data?.locationDetails);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const isWebview = !window.location.pathname.includes("admin");

  const showTruckDetails = (isWebview && devicePosition) || !isWebview;

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  return (
    <div className="p-0 h-[100vh] bg-gray-100 relative">
      {!isWebview && (
        <div className="flex items-center justify-between ">
          <div className="my-0">
            <h2 className="text-lg font-semibold">Live Tracking</h2>

            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={"/admin/truck-categories"}>Trucks</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/admin/truck-categories/${truckId}`}>{truck?.brand}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Tracking</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      )}
      <div className="site-layout-background w-full  overflow-auto">
        <div className="h-full relative">
          {showTruckDetails && (
            <div
              className={`w-full flex justify-center items-center fixed z-10 flex-col md:flex absolute  sm:relative  bottom-2  bg-white  md:flex-nowrap gap-4 shadow-xl rounded-xl overflow-hidden pb-5`}
            >
              <div className="w-full md:w-1/6 bg-white mt-5 rounded-md flex justify-center items-center">
                {/* <div className="w-full flex justify-center item-center">
                  <img
                    src={truck.picture}
                    alt={truck.name}
                    width={200}
                    className="rounded-md"
                  />
                </div> */}
              </div>
              <div className=" w-full flex-1  justify-center items-center bg-white   rounded-md">
                <div className="w-[60%] m-auto flex flex-col justify-center items-center">
                  <div className="flex w-full justify-center items-center gap-2 bg-gray-100 px-5 py-3 rounded-full mb-2">
                    <div>
                      <span className="font-bold">{truck?.model}</span>
                      <span>{` ${truck?.brand}`}</span>{" "}
                    </div>
                  </div>

                  {!isWebview && (
                    <>
                      <div className="w-full m-auto flex justify-between">
                        <div>
                          <strong>Device Object Id: </strong>
                          <span>{truck?.deviceObjectId}</span>
                        </div>
                      </div>
                      <div className="w-full m-auto flex justify-between">
                        <div>
                          <strong>Device Unique Id: </strong>
                          <span>{truck?.deviceUniqueId}</span>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="w-full m-auto flex justify-between">
                    <>
                      {/* <td className="w-1/2 py-1">
                          <strong>Speed: </strong>
                        </td> */}
                      <> {devicePosition?.Speed}Km/h </>
                    </>
                    {isWebview && (
                      <div>
                        <strong> Trips: </strong> {currentTrip}/{numOfTrips}{" "}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            className={`mt-0 sm:mt-4  ${
              isWebview ? "h-[100vh]" : "h-[50vh]"
            } `}
          >                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
            {devicePosition?.Latitude && (
              <MapView devicePosition={devicePosition!} />
            )}
            {/* {devicePosition === undefined && <Spin />} */}
            {!devicePosition && (
              <>
                {!isWebview ? (
                  <>
                    <Alert
                      message={
                        <>
                          Unable to fetch device information <br />
                        </>
                      }
                    />
                    <br />
                    <small>
                      Please confirm that device<b> {deviceObjectId}</b> is
                      active{" "}
                    </small>
                  </>
                ) : (
                  <div className="h-[100vh] w-full fixed flex top-0 left-0 items-center justify-center border-2 ">
                    <div className="  p-5 rounded-md flex flex-col gap-5 w-[80%] m-auto text-center ">
                      <h3 className="opacity-50">
                        {" "}
                        Unable to get current Truck location
                      </h3>
                      <img
                        src={disabledMap}
                        alt=""
                        width="100%"
                        height="100%"
                      />
                      <Button
                        onClick={() => window.location.reload()}
                        className=" bg-[#000000]  text-[#EB5017] rounded-full shadow-lg"
                      >
                        Try again
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
